import { Component, OnInit, NgModule, Input, Output, EventEmitter } from '@angular/core';
import { Routes, RouterModule, Router, ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxCheckBoxModule, DxTextBoxModule, DxFormModule, DxTooltipModule } from 'devextreme-angular';
import { FormsModule } from '@angular/forms';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { CommonService } from '../../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { BaseRequestService } from '../../services/base-request.service';
import { APIConfing } from '../../services/apiconfing.service';
import { CommonPreLoadedService } from 'src/app/core/services/common/common-pre-loaded.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CoreModule } from 'src/app/core/core.module';
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';

@Component({
  selector: 'app-essaccount-verify',
  templateUrl: './essaccount-verify.component.html',
  styleUrls: ['./essaccount-verify.component.scss'],
  standalone: false
})
export class ESSAccountVerifyComponent implements OnInit {
  @Input() validEmailInfo: any;
  @Output() emitRes = new EventEmitter<any>();
  veriftOTPModel: any = {
    consEmailID: '',
    consultantID: '',

    mailOTP: null,
    smsOTP: null
  };
  custVerify: any = {
    text: 'Verify',
    useSubmitBehavior: true,
    width: '100%',
    icon: '',
    type: 'success'
  };
  // validEmailInfo: any = [];
  errMsg: string;
  spinnerProp: any = {
    bdColor: '',
    fullScreen: false,
    size: '',
    color: '',
    type: ''
  };
  spinnerVerify = 'verify';
  isSubLogo: any;
  getImgLogo: any;
  isShowImgLogo: boolean;
  successMsg: any;

  constructor(private router: Router, private route: ActivatedRoute, public common: CommonService,
    private toastrService: ToastrService, private commonAPI: CommonPreLoadedService, private enc: EncryptDecryptService,
    private baseRequset: BaseRequestService, private spinner: NgxSpinnerService) {
    this.spinnerProp.bdColor = APIConfing.data.spinnerProp.bdColor;
    this.spinnerProp.fullScreen = APIConfing.data.spinnerProp.fullScreen;
    this.spinnerProp.size = APIConfing.data.spinnerProp.size;
    this.spinnerProp.color = APIConfing.data.spinnerProp.color;
    this.spinnerProp.type = APIConfing.data.spinnerProp.type;
    // this.route.queryParams
    //   .subscribe(params => {
    //     this.validEmailInfo = JSON.parse(atob(params.verifyAccount));
    //     this.veriftOTPModel.consEmailID = this.validEmailInfo.consEmailID;
    //     this.veriftOTPModel.consultantID = this.validEmailInfo.consultantID;
    //     this.veriftOTPModel.cid = this.validEmailInfo.cid;
    //     this.errMsg = null;
    //   });

    this.isSubLogo = this.commonAPI.getCustomerLogo$().pipe(catchError(err => throwError(err)))
      .subscribe(obj => {
        if (obj && obj.length > 0) {
          this.getImgLogo = obj[0].logoURL;
          this.isShowImgLogo = true;
          this.commonAPI.customerLogo.next(null);
        } else if (obj && obj.length === 0) {
          this.isShowImgLogo = false;
          this.getImgLogo = null;
        }
      });
  }

  ngOnInit() {
    // this.route.queryParams
    //   .subscribe(params => {
    //     if (params && params.verifyAccount) {
    //       this.validEmailInfo = JSON.parse(atob(params.verifyAccount));
    this.veriftOTPModel.consEmailID = this.validEmailInfo.consEmailID;
    this.veriftOTPModel.consultantID = this.validEmailInfo.consultantID;
    this.veriftOTPModel.cid = this.validEmailInfo.cid;
    //     } else {
    // this.veriftOTPModel.consEmailID = this.validEmailInfo.consEmailID;
    //   }
    this.errMsg = null;
    // });
    if (this.veriftOTPModel.cid) {
      // this.commonAPI.fnGetCustomerLogoURL(this.veriftOTPModel.cid, 1);
      this.getImgLogo = localStorage.getItem(this.enc.encryptUsingAES256('customerLogoURL'));
      this.isShowImgLogo = true;
    } else {
      this.isShowImgLogo = false;
    }
  }

  fnResendOTP() {
    this.spinner.show(this.spinnerVerify);
    const reSendOTP: any = {
      consEmailID: this.validEmailInfo.consEmailID,
      cid: this.validEmailInfo.cid || 0
    };
    this.baseRequset.fnpost('/CSS/Consultant/ForgotConsultantPasswd', this.common.fnReturnEncryptedPayload(reSendOTP))
      .subscribe((getResData: any) => {
        if (getResData && getResData.code === this.common.status.success) {
          this.toastrService.success(getResData.message, 'Success');
          this.validEmailInfo.msg = getResData.message || '';
          this.spinner.hide(this.spinnerVerify);
        } else if (getResData.code === 'E002') {
          this.toastrService.error(APIConfing.data.E002, 'Error');
          this.spinner.hide(this.spinnerVerify);
        } else if (getResData.code === 'E001') {
          this.toastrService.error(getResData.message, 'Error');
          this.spinner.hide(this.spinnerVerify);
        } else if (getResData.code === this.baseRequset.warning.code) {
          this.toastrService.warning(getResData.message, 'Details');
          this.spinner.hide(this.spinnerVerify);
        } else {
          this.spinner.hide(this.spinnerVerify);
        }
      }, err => {
        this.toastrService.error(APIConfing.data.E002);
        this.spinner.hide(this.spinnerVerify);
      });
  }

  fnVerifyOTP(data: any) {
    this.spinner.show(this.spinnerVerify);
    const veriftOTPModel: any = {
      consEmailID: this.veriftOTPModel.consEmailID,
      consultantID: this.veriftOTPModel.consultantID,
      cid: this.veriftOTPModel.cid,
      mailOTP: data.mailOTP ? data.mailOTP.toString() : '',
      smsOTP: data.mailOTP ? data.mailOTP.toString() : ''
    };
    this.baseRequset.fnpost('/CSS/Consultant/GetValidateConsultantOTPs', this.common.fnReturnEncryptedPayload(veriftOTPModel))
      .subscribe((getResData: any) => {
        if (getResData && getResData.code === this.common.status.success) {
          if (getResData.dataObject) {
            if (this.enc.decryptUsingAES256(getResData.dataObject) === this.validEmailInfo.consultantID + '/' + this.validEmailInfo.cid) {
              this.toastrService.success(getResData.message, 'Success');
              this.spinner.hide(this.spinnerVerify);
              // this.router.navigate(['/New-Password'],
              //   {
              const queryParams = {
                consEmailID: this.validEmailInfo.consEmailID,
                cid: this.validEmailInfo.cid,
                consultantID: this.validEmailInfo.consultantID,
                route: 'New-Password',
                otp: veriftOTPModel.mailOTP
              }
              this.emitRes.emit(queryParams);
            } else {
              this.spinner.hide(this.spinnerVerify);
              this.toastrService.error('Authentication Failed', 'Error');
            }
          } else {
            this.spinner.hide(this.spinnerVerify);
            this.toastrService.error('Authentication Failed', 'Error');
          }

          //   });

        } else if (getResData.code === 'E002') {
          this.toastrService.error(APIConfing.data.E002);
          this.spinner.hide(this.spinnerVerify);
        } else if (getResData.code === 'E001') {
          this.toastrService.error(getResData.message, 'Error');
          this.spinner.hide(this.spinnerVerify);
        } else if (getResData.code === this.baseRequset.warning.code) {
          this.toastrService.warning(getResData.message, 'Details');
          this.spinner.hide(this.spinnerVerify);
        } else {
          this.spinner.hide(this.spinnerVerify);
        }
      });
  }
  fnBackToLogin() {
    // if (sessionStorage.getItem('urlData')) {
    //   const getURLData: any = atob(sessionStorage.getItem('urlData'));
    //   const getCID = atob(getURLData.cid);
    //   this.router.navigate(['/Login'],
    //     { queryParams: { email: btoa(this.validEmailInfo.consEmailID), cid: getCID || 0 } });
    // } else {
    //   this.router.navigate(['/Login'],
    //     { queryParams: { email: btoa(this.validEmailInfo.consEmailID) } });
    // }
    // this.router.navigate(['/login'],
    //   {
    //     queryParams: {
    //       userName: btoa(this.validEmailInfo.consEmailID), cid: btoa(this.validEmailInfo.cid),
    //       consultantID: btoa(this.validEmailInfo.consultantID)
    //     }
    //   });
    const queryParams = {
      userName: this.validEmailInfo.consEmailID, cid: this.validEmailInfo.cid,
      consultantID: this.validEmailInfo.consultantID,
      route: 'Login'
    }
    this.emitRes.emit(queryParams);
  }
}
const routes: Routes = [
  { path: '', component: ESSAccountVerifyComponent }
];
@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    // DxButtonModule,
    // DxCheckBoxModule,
    // DxTextBoxModule,
    DxFormModule,
    FormsModule,
    // DxTooltipModule,
    // NgxSpinnerModule,
    CoreModule
  ],
  declarations: [ESSAccountVerifyComponent],
  exports: [ESSAccountVerifyComponent]
})
export class ESSAccountVerifyModule { }
